<script lang="ts">
    import InfoIcon from "../icons/InfoIcon.svelte";
    import { toolTip } from "./ToolTip";

    export let content: string = "";
    export let url: string = "";

    let element: HTMLElement;
    $: if (typeof content !== "undefined" && content.length > 0) {
        toolTip.Add(element, {
            content: content,
        });
    }
</script>

<div bind:this={element} class="d-inline icon icon-sm text-muted">
    {#if url.length > 0}
    <a href={url}><InfoIcon /></a>
    {:else}
    <InfoIcon />
    {/if}
</div>